export default __webpack_public_path__ + "static/Graphik-Regular-Web-4817c3e10169294009dfa1434d7e12d2.svg";